var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeFilled = function SvgHomeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.657 18.615c0 1.178.736 1.89 1.955 1.89h10.785c1.21 0 1.954-.712 1.954-1.89v-6.214L12.507 6.67c-.319-.278-.703-.27-1.014 0l-6.836 5.732v6.214Zm9.493.352H9.858v-5.233c0-.384.253-.63.637-.63h3.026c.384 0 .63.246.63.63v5.233Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.264c0 .426.327.794.85.794.254 0 .483-.14.687-.303l8.111-6.811c.23-.196.491-.196.72 0l8.103 6.811c.196.164.425.303.679.303.482 0 .85-.303.85-.777a.844.844 0 0 0-.319-.679L13.17 3.448c-.711-.597-1.61-.597-2.322 0l-8.52 7.154a.855.855 0 0 0-.327.662Z",
    fill: "currentColor"
  })));
};
export default SvgHomeFilled;